import React from 'react';
import cx from 'classnames';
import css from './PauseButton.module.scss';

const PauseButton = ({ isPaused, onToggle, disabled }) => (
  <button
    type="button"
    className={cx(css.PauseButton, {
      [css.Paused]: isPaused,
      [css.Disabled]: disabled,
    })}
    onClick={onToggle}
    disabled={disabled}
    aria-label={isPaused ? '继续' : '暂停'}
    title={isPaused ? '继续 (Resume)' : '暂停 (Pause)'}
  >
    <span className={css.HexFrame} />
    <span className={css.Glyph} aria-hidden="true">
      {isPaused ? (
        // ▶ play 三角
        <svg viewBox="0 0 24 24" width="20" height="20">
          <polygon points="6,4 6,20 20,12" />
        </svg>
      ) : (
        // ‖ pause 双竖条
        <svg viewBox="0 0 24 24" width="20" height="20">
          <rect x="6" y="4" width="4" height="16" rx="0.5" />
          <rect x="14" y="4" width="4" height="16" rx="0.5" />
        </svg>
      )}
    </span>
  </button>
);

export default PauseButton;
